import { requestSignInDecision } from './signInDecision'
import { createAuthProvider } from './createAuthProvider'
import { getSupabaseConfig } from '../supabase/config'
import { allowWorkspaceSignIn } from '../data/workspace'

// The content-free boundary and the mounted workspace observe one auth lifecycle.
export const authProvider = createAuthProvider()
const originalSignIn = authProvider.signIn.bind(authProvider)
authProvider.signIn = async () => {
  if (!await requestSignInDecision()) return null
  const config = getSupabaseConfig()
  if (config) allowWorkspaceSignIn({ project: config.url, environment: config.environment })
  return originalSignIn()
}
